"use strict";

require("core-js/modules/es6.object.define-property");

var _styledComponents = _interopRequireDefault(require("styled-components"));

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.UserInfoBlock = exports.UserInfo = exports.LogoWrapper = exports.HeaderTop = void 0;

function _interopRequireDefault(a) {
  return a && a.__esModule ? a : {
    "default": a
  };
}

var HeaderTop = _styledComponents["default"].div.withConfig({
  displayName: "styles__HeaderTop"
})(["display:flex;justify-content:space-between;"]);

exports.HeaderTop = HeaderTop;

var LogoWrapper = _styledComponents["default"].a.withConfig({
  displayName: "styles__LogoWrapper"
})(["width:125px;display:block;"]);

exports.LogoWrapper = LogoWrapper;

var UserInfo = _styledComponents["default"].a.withConfig({
  displayName: "styles__UserInfo"
})(["display:flex;font-size:0.75rem;align-items:center;color:", ";"], function (a) {
  return a.theme.colors.grey.dark;
});

exports.UserInfo = UserInfo;

var UserInfoBlock = _styledComponents["default"].div.withConfig({
  displayName: "styles__UserInfoBlock"
})(["margin:0 1rem;"]);

exports.UserInfoBlock = UserInfoBlock;